import { render, staticRenderFns } from "./martin_deal_details.vue?vue&type=template&id=f944960c&scoped=true&"
import script from "./martin_deal_details.vue?vue&type=script&lang=js&"
export * from "./martin_deal_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f944960c",
  null
  
)

export default component.exports